import { render, staticRenderFns } from "./Bmap.vue?vue&type=template&id=1b44a825&scoped=true&"
import script from "./Bmap.vue?vue&type=script&lang=js&"
export * from "./Bmap.vue?vue&type=script&lang=js&"
import style0 from "./Bmap.vue?vue&type=style&index=0&id=1b44a825&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b44a825",
  null
  
)

export default component.exports